module.exports = __webpack_public_path__ + "static/media/ErrorIcon.87696f0d.svg";